import React, { useEffect, useRef, useState } from "react";
import VideoJS from "./components/VideoJs";
import Drawer from "./components/Drawer/Drawer";
import ChatRoom from "./components/Chat/ChatRoom";
import Tabs from "./components/Tabs";
import DrawerClickItem from "./components/Drawer/DrawerClickItem";
import { questionsConfig } from "./configs/questions";
import { useVideoContext } from "./stores/video";
import { getVideoPath } from "./utils/util";
import { useChatContext } from "./stores/chat";
import { HelpOutline } from "@mui/icons-material";
import SettingMenu from "./components/SettingMenu";
import { MenuItemEnum } from "./types/SettingMenu";

const videoJsOptions = {
  autoplay: false,
  controls: false,
  responsive: true,
  fluid: true,
  sources: JSON.parse(JSON.stringify(getVideoPath("/Utils問候語.webm"))),
};

const tabItems = [
  { value: "default", label: "精選" },
  { value: "steaming", label: "即時" },
];

function App() {
  const [tab, setTab] = useState(1);
  const { play, status } = useVideoContext();
  const {
    isLoadingAvatar,
    setHistory,
    isLoadingStt,
    isLoadingGPT,
    isRecording,
    activeQuestion,
    setActiveQuestion,
  } = useChatContext();
  const useAvatar = useRef(false);

  useEffect(() => {
    if (status === "ready") {
      setTimeout(() => {
        play && play(getVideoPath("/Utils問候語.webm"));
      }, 800);
    }
  }, [status, play]);

  function handleClickMenu(type: MenuItemEnum, value: any) {
    switch (type) {
      case MenuItemEnum.delete:
        setHistory([]);
        break;
      case MenuItemEnum.avatar:
        if (typeof value !== "boolean") break;
        useAvatar.current = value;
        break;
      default:
        console.error("Unsupported menu item type");
    }
  }

  return (
    <div className="App bg-green-50">
      <div className="flex">
        <div className="w-full h-screen p-6 pr-3 flex items-center justify-center">
          <div className="w-full max-w-[1400px] h-full relative bg-white rounded-3xl p-4 flex items-center shadow-lg">
            {/* <img
              src={process.env.PUBLIC_URL + "/images/Logo.png"}
              alt="logo"
              className="absolute left-[30px] top-[30px] max-w-[300px] z-10"
            />
            <VideoJS options={videoJsOptions} /> */}

            <ChatRoom
              useAvatar={useAvatar.current}
              onGetAvatar={(src) => play && play(src)}
            />
          </div>
        </div>
        {/* <Drawer>
          <div className="w-full h-full p-6 pl-3">
            <div className="flex flex-col w-full h-full bg-[rgba(255,255,255,0.4)] rounded-3xl overflow-hidden">
              <div className="p-4">
                <div className="flex w-full justify-center relative">
                  <Tabs
                    onClick={(value) => {
                      setTab(value);
                    }}
                    value={tab}
                    items={tabItems}
                  />
                  <SettingMenu
                    onClickMenu={handleClickMenu}
                    disabled={
                      isRecording ||
                      isLoadingAvatar ||
                      isLoadingGPT ||
                      isLoadingStt ||
                      tab !== 1
                    }
                  />
                </div>
              </div>
              <div className="w-full h-full max-h-[calc(100%_-_66px)] overflow-auto">
                <div className={`px-2 ${tab !== 0 && "hidden"}`}>
                  {questionsConfig.map(({ q, filename, a }, index) => (
                    <DrawerClickItem
                      onClick={() => {
                        setActiveQuestion(index);
                        play && play(getVideoPath(filename));
                      }}
                      active={index === activeQuestion}
                      key={index}
                    >
                      <>
                        <div className="flex">
                          <HelpOutline
                            className={`${
                              index === activeQuestion
                                ? "text-rose-600"
                                : "text-gray-400"
                            } mr-2 flex-shrink-0`}
                          />
                          {q}
                        </div>
                        <div
                          className={`${
                            index === activeQuestion ? "block" : "hidden"
                          } text-sm mt-2 ml-8`}
                        >
                          {a}
                        </div>
                      </>
                    </DrawerClickItem>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Drawer> */}
      </div>
    </div>
  );
}

export default App;
